export default __webpack_public_path__ + "static/media/hotspotbg.2948620f.jpg";